export default {
    addDashboard: "Add dashboard",
    saveDashboard: "Dashboard saved successfully",
    dashboardButtons: {
        filters: "Filters",
        zoom: "Zoom",
        remove: "Remove",
        move: "Move",
        edit: "Edit",
        save: "Save",
        close: "Close",
        addGraph: "Add component",
        configure: "Configure",
    },
    deleteModal: {
        title: 'Delete Dashboard',
        body: 'Are you sure you want to delete the dashboard "{dashboardName}"?',
        cancel: 'Cancel',
        confirm: 'Confirm',
    },
    filters: {
        title: 'Choose filters to apply',
        labels: {
            generalFilters: 'General filters',
            dashboardFilters: 'Dashboard filters',
            graphFilters: 'Graph filters',
            noFilters: 'No filters applied',
        },
        addFilter: 'Add filter',
        addedFilter: 'This filter has already been added',
    },
    editNameModal: {
        title: 'Rename graph',
        rename: 'Rename',
    },
    graphTitles: {
        VARIANTS: 'Variants',
        TRANSITIONS: 'Transitions',
        ACTIVITIES: 'Activities',
        ATTRIBUTE: 'Attribute',
        OTHERS: 'Others',
    },
    graphSubtitles: {
        FREQUENCY: 'Frequency',
        frequencyvsaverage: 'By frequency and duration',
        DURATION_AVG: 'Average duration',
        DURATION_MAX: 'Maximum duration',
        DURATION_MIN: 'Minimum duration',
        DURATION_STD: 'Standard deviation time',
        attributeInformation: 'Standard analysis',
        FREQUENCY_AND_DURATION: 'Frequency and duration',
    },
    filterTags: {
        own: "Chart",
        dashboard: "Dashboard",
        general: "General",
    },
}
